import { AbstractControl } from '@angular/forms';

export const required = (control: AbstractControl) => {
  const { value } = control;

  if ((value !== null && typeof value !== 'undefined' && String(value).toString().trim().length) || (Array.isArray(value) && value.length)) return null;

  return { required: { message: 'Campo obrigatório' } };
};
